module.exports = __webpack_public_path__ + "static/media/Photo11.8480dce6.jpg";